import React, { useEffect, useState } from 'react'
import { ArrowForwardIcon, DownloadIcon } from '@chakra-ui/icons'
import { Container, Flex, Box, Button, Text, Divider, Image, Center } from '@chakra-ui/react'
import { PospImages } from 'Assets/Posp'
import { Link } from 'react-router-dom'
import { useDeviceType } from 'app/hooks'

interface Iprops {
  values: any
  state?: any
}

export const ActiveStepper = (props: Iprops) => {
  const { key, subhead, proceedRoute } = props.values
  const { state } = props
  const { isMobile } = useDeviceType()
  return (
    <Container maxWidth='90%'>
      <Box width='100%' height={isMobile ? 70 : 94}>
        <Flex
          background='#EFF5FF 0% 0% no-repeat padding-box;'
          justifyContent='space-between'
          // paddingX={10}
          // paddingY={5}
          alignItems='center'
        >
          <Box>
            <Flex justifyContent='space-between' alignItems='center'>
              <div
                style={{
                  padding: '0 16px',
                  width: isMobile ? '60px' : 'auto',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Divider height={isMobile ? '25px' : '30px'} orientation='vertical' />
                <Image
                  width={'full'}
                  src={
                    state === 'final_iib_verification'
                      ? PospImages.FinalVerificationIcon
                      : PospImages.ActiveIcon
                  }
                />
                <Divider height={isMobile ? '25px' : '30px'} orientation='vertical' />
              </div>

              <Flex flexDirection='column'>
                <Text
                  fontSize={isMobile ? 'sm' : 'md'}
                  color='#366BE2'
                  style={{
                    font: 'normal normal medium 18px/24px Roboto',
                  }}
                  fontWeight='bold'
                >
                  {key}
                </Text>
                <Text fontSize={isMobile ? '2xs' : 'sm'}>{subhead}</Text>
              </Flex>
            </Flex>
          </Box>

          {state !== 'final_iib_verification' ? (
            <Link to={proceedRoute}>
              {isMobile ? (
                <Center mr={2} width='30px' height='30px' bg='#01317f' rounded='full'>
                  <ArrowForwardIcon m='auto' color='white' />
                </Center>
              ) : (
                <Button
                  rightIcon={<ArrowForwardIcon />}
                  style={{ marginRight: '16px' }}
                  variant='solid'
                  rounded='full'
                  px={'30px'}
                >
                  PROCEED
                </Button>
              )}
            </Link>
          ) : null}
        </Flex>
      </Box>
    </Container>
  )
}

export const InactiveStepper = (props: Iprops) => {
  const { key, status, message, proceedRoute } = props.values || {}
  const { state } = props
  const [errorText, setErrorText] = useState('')
  const { isMobile } = useDeviceType()
  useEffect(() => {
    if (message && Object.keys(message)?.length) {
      const keys: any[] = []
      let totalErrors = 0
      Object.keys(message).forEach((key) => {
        keys.push(key)
        totalErrors = totalErrors + parseInt(message[key].length)
      })

      const errText =
        message[keys[0]][0] + (totalErrors - 1 >= 1 ? ` and ${totalErrors - 1} more` : '')

      setErrorText(errText)
    }
  }, [message])

  return (
    <Container maxWidth='90%'>
      <Flex alignItems='center' justifyContent={'space-between'}>
        <Flex alignItems='center'>
          <div
            style={{
              padding: '0 16px',
              display: 'flex',
              width: isMobile ? '55px' : 'auto',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Divider height={isMobile ? '25px' : '30px'} orientation='vertical' />
            {status === 'COMPLETE' ? (
              <Image src={PospImages.CompletedIcon} />
            ) : status === 'PENDING' ? (
              <Image src={PospImages.PendingIcon} />
            ) : status === 'REJECTED' ? (
              <Image src={PospImages.RejectedIcon} />
            ) : (
              <Box
                rounded={'full'}
                height={isMobile ? 6 : 5}
                width={isMobile ? 6 : 5}
                border='1px solid #B5B5B5'
              ></Box>
            )}

            <Divider height={isMobile ? '25px' : '30px'} orientation='vertical' />
          </div>

          <Flex flexDirection={'column'} alignItems={'flex-start'}>
            <Text fontSize={isMobile ? 'sm' : 'md'}>{key}</Text>
            {status === 'REJECTED' ? (
              <Box fontStyle='italic' color={'red'} fontSize={isMobile ? '2xs' : 'sm'}>
                {errorText}
              </Box>
            ) : null}
            {status === 'PENDING' ? (
              <Box
                fontStyle='italic'
                letterSpacing={'1px'}
                fontSize={isMobile ? '2xs' : 'sm'}
                color={'#B5B5B5'}
              >
                Verification Pending
              </Box>
            ) : null}
            {state === 'final_iib_verification' && !!message?.exam_certificate?.length && (
              <Button
                onClick={() => window.open(message?.exam_certificate)}
                leftIcon={<DownloadIcon />}
                rounded='full'
                fontSize={'xs'}
                color='#366BE2'
                variant='link'
                mt={1}
              >
                Training Certificate
              </Button>
            )}
            {state === 'final_iib_verification' &&
              status === 'COMPLETE' &&
              !!message?.irda_certificate_url?.length && (
                <Button
                  onClick={() => window.open(message?.irda_certificate_url)}
                  leftIcon={<DownloadIcon />}
                  rounded='full'
                  fontSize={'xs'}
                  color='#366BE2'
                  variant='link'
                  mt={1}
                >
                  IRDAI Certificate
                </Button>
              )}
            {state === 'final_iib_verification' &&
              status === 'COMPLETE' &&
              !!message?.signed_agreement_url?.length && (
                <Button
                  onClick={() => window.open(message?.signed_agreement_url)}
                  leftIcon={<DownloadIcon />}
                  rounded='full'
                  fontSize={'xs'}
                  color='#366BE2'
                  variant='link'
                  mt={1}
                >
                  Agreement
                </Button>
              )}
          </Flex>
        </Flex>

        {status === 'REJECTED' && state !== 'final_iib_verification' ? (
          <Link to={proceedRoute}>
            {isMobile ? (
              <Center mr={2} width='30px' height='30px' bg='#01317f' rounded='full'>
                <ArrowForwardIcon m='auto' color='white' />
              </Center>
            ) : (
              <Button variant='outline' mr='16px' rounded={'full'}>
                upload again
              </Button>
            )}
          </Link>
        ) : null}
      </Flex>
    </Container>
  )
}
